import React from "react";
import ReactDOM from "react-dom";

// Our own glass utility + base-component layer (replaces Bootstrap CSS).
// A small, themed subset of exactly the classes this app uses. Loaded
// first so tokens/overrides and screen CSS win specificity.
import "./styles/glass-utils.css";
// AdminLTE-specific component shims (small-box/info-box/direct-chat/card-tools
// /bg-gradient/etc.) — replaces adminlte.min.css now that it's removed.
import "./styles/adminlte-components.css";

// v4 design tokens — must come first so variables/font are defined before other CSS.
import "./styles/monarc-tokens.css";
// Canonical design-pack tokens (glass tokens + per-tab accents) + atomic glass
// primitives (.surface/.tile/.tag/.icon) the v4 mockups are built from.
import "./styles/v4-tokens.css";
import "./styles/v4-primitives.css";

import "./index.css";

import {App} from "./App";

import registerServiceWorker from './registerServiceWorker';

// v4 re-skin overrides — imported after page CSS so they win specificity.
import "./styles/monarc-v4-overrides.css";
// Liquid Glass app layer — atmospheric backdrop + frosted surfaces (last).
import "./styles/liquid-glass.css";


ReactDOM.render( <App /> , document.getElementById('root'));

registerServiceWorker();

// DEV ONLY — CRA 3.x's runtime-error overlay (react-error-overlay) can get
// stuck as an INVISIBLE full-screen iframe at max z-index that swallows every
// click: the app looks fine and scrolls, but nothing is clickable ("the site
// is hanging"). A legitimately displayed overlay paints visible content, so
// only remove the iframe when nothing inside it has any layout height.
if (process.env.NODE_ENV === 'development') {
  setInterval(() => {
    document.querySelectorAll('body > iframe').forEach((f) => {
      if (getComputedStyle(f).zIndex !== '2147483647') return;
      let stuck = false;
      try {
        const b = f.contentDocument && f.contentDocument.body;
        stuck = !!b && ![...b.children].some((el) => el.getBoundingClientRect().height > 0);
      } catch (e) { /* cross-origin iframe — not the overlay, leave it */ }
      if (stuck) f.remove();
    });
  }, 2000);
}